import { render, staticRenderFns } from "./reportSelectRatio.vue?vue&type=template&id=0151664e&scoped=true&"
import script from "./reportSelectRatio.vue?vue&type=script&lang=js&"
export * from "./reportSelectRatio.vue?vue&type=script&lang=js&"
import style0 from "./reportSelectRatio.vue?vue&type=style&index=0&id=0151664e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151664e",
  null
  
)

export default component.exports